import { type HTMLProps } from "react";

import { useFlippers } from "@shared/context/FlippersContext";

import * as styles from "./FlipperPriceBlur.styles";

const FlipperPriceBlur = ({ children }: HTMLProps<HTMLSpanElement>) => {
  const [hasBlurredValue] = useFlippers("km_blurred_product_prices");
  const blur = [hasBlurredValue && styles.blur];

  const blurTestID = hasBlurredValue ? "blurred-price" : "unblurred-price";

  return (
    <span css={blur} data-testid={blurTestID}>
      {children}
    </span>
  );
};

export { FlipperPriceBlur };
